import React from 'react';
import Testimonials from '../components/Testimonials';
import '../styles/AvisPage.css';

const AvisPage = () => {
  return (
    <div className="avis-page">
      {/* Hero Section */}
      <section className="avis-hero">
        <div className="container">
          <p className="contact-subtitle">TÉMOIGNAGES CLIENTS</p>
          <h1 className="contact-title">Ce que disent nos clients</h1>
          <div className="title-underline"></div>
          <p className="contact-description">
            La satisfaction de nos clients est notre plus grande fierté. Découvrez leurs avis.
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <Testimonials />
    </div>
  );
};

export default AvisPage;
